import { useLayoutContext } from '@/context/LayoutContext';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.module.css';
import Button from '@/components/common/Button';
import { useTranslations } from 'next-intl';
import { useRouterPath } from '@/functions/routerPath';
import { useRouter } from 'next/navigation';
import { TRIGGERS } from '@/api/global';
import ProductCard from '@/components/pages/product/ProductsContent/ProductCard';

export default function BasketModal() {
  const { basket, setBasket, setTrigger, checkIfLogin, totalPrice, priceSymbol } =
    useLayoutContext();
  const tCommon = useTranslations('common');
  const routerPath = useRouterPath();
  const router = useRouter();

  const basketJson = JSON.stringify(basket);
  //   const [totalPrice, setTotalPrice] = useState<number>();
  //   useEffect(() => {
  //     setTotalPrice(
  //       basket.reduce((sum, product) => sum + Number(String(product.price)?.replace('$', '')), 0),
  //     );
  //   }, [basketJson]);
  // const totalPrice = useMemo(
  //   () =>
  //     basket.reduce(
  //       (sum, product) =>
  //         sum + Number(String(product.price).replace('$', '')) * (Number(product.count) ?? 1),
  //       0,
  //     ),
  //   [basket],
  // );
  return (
    <div className={`${styles.wrapper}`}>
      <div className={`${styles.basket_grid}`}>
        {basket?.map((item, index) => (
          <ProductCard
            item={item}
            key={index}
            direction="horizontal"
            showBageds={false}
            showButton={false}
            showRate={false}
            // showText={false}
            // showCheckBox={false}
            showCartButtons={true}
            showDelete={true}
            count={Number(item?.count)}
            // className={styles.productCard}
            movingCard={false}
            showDistance={false}
            showInBasket={true}
            index={index}
            showShop={false}
            showRemove={true}
            inBasket={true}
          />
        ))}
      </div>
      <div className={`${styles.drawer_foot}`}>
        <div className={`${styles.drawer_sub}`}>
          <span>{tCommon('subTotal')}</span>
          <span className={`${styles.mono}${styles.drawer_sub_num}`} dir="ltr">
            {totalPrice?.toLocaleString()} {priceSymbol}
          </span>
        </div>
        <p className={`${styles.drawer_note}`}>{/* {tCommon('freeShipping')} */}</p>
        <Button
          className="btn btn-primary squareButton noBoxShadow w-full"
          onClick={(e) => {
            checkIfLogin &&
              checkIfLogin(() => {
                setTrigger(TRIGGERS.EMPTY);
                router.push(routerPath('/checkout'));
              }, e);
          }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="5" y="11" width="14" height="9" rx="2"></rect>
            <path d="M8 11V8a4 4 0 0 1 8 0v3"></path>
          </svg>{' '}
          {tCommon('checkout')}
        </Button>
        <Button
          className="btn  btn-white  squareButton w-full"
          onClick={() => {
            setTrigger(TRIGGERS.EMPTY);
            router.push(routerPath('/products'));
          }}
        >
          {tCommon('continueShopping')}
        </Button>
      </div>
    </div>
  );
}
